import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ACertificateHttpService } from "@coso/connection-forms";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { parseErrorBlob } from "../utils/parse-error-blob";

@Injectable({
  providedIn: "root"
})
export class CertificateHttpService extends ACertificateHttpService {
  baseRoute = `/api/certificate`;
  constructor(private http: HttpClient) {
    super();
  }

  exportCertificate(): Observable<Blob> {
    return this.http.get(`${this.baseRoute}/export`, { responseType: "blob" }).pipe(catchError(parseErrorBlob));
  }

  getCertificateThumbprint(): Observable<string> {
    return this.http.get(`${this.baseRoute}/thumbprint`, { responseType: "text" });
  }
}
